import { Alert } from '@mui/material';
import { type DeliveryLineAmounts, isLineAmountInconsistent } from '@prospero/shared';
import { useTranslation } from 'react-i18next';

// Hint only: a misread quantity never blocks saving the line.
export function LineAmountWarning(line: DeliveryLineAmounts) {
  const { t } = useTranslation('goodsReceiving');
  if (!isLineAmountInconsistent(line)) {
    return null;
  }
  return (
    <Alert severity="warning" sx={{ mt: 1 }}>
      {t('lineAmountMismatchWarning')}
    </Alert>
  );
}
